const tipoReagendamentoEnum = {
    APROVAR: 1,
    REPROVAR: 2
};

export default tipoReagendamentoEnum;